import React, { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { BookOpen, Crown, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function MagGate() {
  const [access, setAccess] = useState(null);
  useEffect(() => {
    api.get("/mag/access").then((r) => setAccess(r.data)).catch(() => setAccess({ allowed: false }));
  }, []);

  if (!access) return (
    <div className="flex items-center justify-center py-24 text-ink-muted">
      <Loader2 className="h-5 w-5 animate-spin" />
    </div>
  );
  if (access.allowed) return <Outlet />;

  return (
    <div className="max-w-xl mx-auto py-16 text-center space-y-5" data-testid="mag-locked-screen">
      <div className="mx-auto w-16 h-16 rounded-2xl bg-brand-amber/15 flex items-center justify-center">
        <BookOpen className="h-8 w-8 text-brand-amber" />
      </div>
      <h1 className="font-display text-2xl font-bold">Digital Magazine Studio</h1>
      <p className="text-sm text-ink-secondary leading-relaxed">
        Run your own online magazine — an AI-assisted CMS with a public reader site, weekly
        newsletter digests and automatic social sharing. This studio is included in the
        <span className="text-brand-amber font-bold"> Network</span> package.
      </p>
      <div className="rounded-xl border border-line bg-bg-surface p-4 text-left text-xs text-ink-secondary space-y-1.5">
        <div>• Full magazine CMS with AI Writer, categories &amp; authors</div>
        <div>• Public reader portal with your station's live radio player</div>
        <div>• Weekly newsletter digest with subscriber management</div>
        <div>• Auto-share every published story to your social accounts</div>
        <div>• AI image generation, cropping &amp; photo filters</div>
      </div>
      <Link to="/dashboard/subscription" data-testid="mag-locked-upgrade-btn"
        className="inline-flex items-center gap-2 rounded-full bg-brand-amber text-black px-6 py-2.5 text-sm font-bold">
        <Crown className="h-4 w-4" /> Upgrade to Network
      </Link>
      <p className="text-[11px] text-ink-muted">Your current plan: <span className="capitalize">{access.plan || "free"}</span></p>
    </div>
  );
}
